import { RateDataListI } from "../pages/property/property.type";
import { HotelDataListI } from "../redux/slices/enviromentSlice/EnviromentSlice.type";

export const getMinPrice = (prices: Array<string | undefined>) => {
  return prices.reduce((acum, current, currentI) => {
    if (!acum || !current) return acum ?? prices[currentI];
    return +current < +acum ? current : acum;
  });
};

export const getMaxPrice = (prices: Array<string | undefined>) => {
  return prices.reduce((acum, current, currentI) => {
    if (!acum || !current) return acum ?? prices[currentI];
    return +current > +acum ? current : acum;
  });
};

export const getRateDataListMinPrice = (
  rateDataList: RateDataListI[] | undefined
) => {
  return rateDataList?.reduce((acc, currentRate) => {
    const minPrice = currentRate.priceNoOffer ?? currentRate.price;
    if (acc === undefined || +minPrice < acc) {
      return (acc = +minPrice);
    }
    return acc;
  }, undefined as undefined | number);
};

export const getHotelMinPrice = (
  hotel: HotelDataListI,
  options?: {
    refundable?: boolean;
  }
) => {
  if (options?.refundable) {
    return getMinPrice([hotel.priceRefundable, hotel.priceNoOfferRefundable]);
  }
  return getMinPrice([
    hotel.priceRefundable,
    hotel.priceNoOfferRefundable,
    hotel.priceNotRefundable,
    hotel.priceNoOfferNotRefundable,
  ]);
};

export const isHotelInOffer = (hotel: HotelDataListI) => {
  const minOfferPrice = getMinPrice([
    hotel.priceNotRefundable,
    hotel.priceRefundable,
  ]);
  const minNoOfferPrice = getMinPrice([
    hotel.priceNoOfferNotRefundable,
    hotel.priceNoOfferRefundable,
  ]);
  if (!minOfferPrice) {
    return false;
  }
  if (!minNoOfferPrice) {
    return true;
  }
  return minOfferPrice < minNoOfferPrice;
};

export const getHotelMinMaxPrices = (hotel: HotelDataListI) => {
  return {
    minPrice: getMinPrice([
      hotel.priceRefundable,
      hotel.priceNoOfferRefundable,
      hotel.priceNotRefundable,
      hotel.priceNoOfferNotRefundable,
    ]),
    maxPrice: getMaxPrice([
      hotel.priceRefundable,
      hotel.priceNoOfferRefundable,
      hotel.priceNotRefundable,
      hotel.priceNoOfferNotRefundable,
    ]),
  };
};
